import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import type {DurationNotificationProps} from './duration-notification.types';
import {TimelineItemDurationContainerType} from './duration-notification.types';
import styles from './duration-notification.module.scss';

export function DurationNotification({className = '', type = TimelineItemDurationContainerType.Default, ...props}: DurationNotificationProps): ReactElement<any> {
  const getClassesFromType = (): string => {
    switch (type) {
      case TimelineItemDurationContainerType.Blue:
        return styles.blue;
      case TimelineItemDurationContainerType.Purple:
        return styles.purple;
      case TimelineItemDurationContainerType.Green:
        return styles.green;
      case TimelineItemDurationContainerType.Default:
        return styles.default;
      default:
        return styles.default;
    }
  };

  return (
    <div className={`${styles.container} ${className} ${getClassesFromType()} radius-round`}>
      <Text val={props.duration} size={TextSize.XXXSMALL} className={`color-white ${styles.text}`} bold />
    </div>
  );
}
